import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useFetch } from '@/modules/core/composables/useFetch'
import { useAuthStore } from '@/modules/auth/stores/auth-store'

export const useUserStore = defineStore('public/userStore', () => {
  const authStore = useAuthStore()

  /////////////////////////////////////////////////////////////////////////////
  // types
  /////////////////////////////////////////////////////////////////////////////

  const errorMessage = ref(null)

  /////////////////////////////////////////////////////////////////////////////
  // Actions
  /////////////////////////////////////////////////////////////////////////////

  const createCompanyUser = async (company_user, { slug }: { slug: string }) => {
    try {
      await useFetch(`/v4/${slug}/public/users/company-user-register`).post({ company_user })
      login(authStore.access_token, slug)
    } catch (err) {
      errorMessage.value = err.message
    }
  }

  const createInvestorUser = async (investor_user, { slug }: { slug: string }) => {
    try {
      await useFetch(`/v4/${slug}/public/users/investor-user-register`).post({ investor_user })
      login(authStore.access_token, slug)
    } catch (err) {
      errorMessage.value = err.message
    }
  }

  const createInvestorUserWithToken = async (investor_user, { slug }: { slug: string }) => {
    try {
      await useFetch(`/v4/${slug}/public/users/investor-user-register-with-token`).post({ investor_user })
      login(authStore.access_token, slug)
    } catch (err) {
      errorMessage.value = err.message
    }
  }

  const clearErrorMessage = () => {
    errorMessage.value = null
  }

  const login = (access_token: string, slug: string) => {
    const baseUrl = import.meta.env.VITE_VENTURE360_REDIRECT_URL
    const accessTokenParam = `access_token=${access_token}`
    const slugParam = slug ? `slug=${slug}` : ''
    const queryParams = [accessTokenParam, slugParam].filter((param) => param).join('&')

    window.location.href = `${baseUrl}/user?${queryParams}`
  }

  return {
    createCompanyUser,
    createInvestorUser,
    createInvestorUserWithToken,
    clearErrorMessage,
    errorMessage,
  }
})
